import type { ReactNode } from 'react';

interface Props {
  /** Иконка/эмодзи слева сверху (например, 📋 или React-svg). */
  icon?: ReactNode;
  /** Заголовок — что произошло («Нет данных», «Ничего не найдено»). */
  title: string;
  /** Подзаголовок — что делать дальше («Попробуйте сменить фильтры»). */
  body?: ReactNode;
  /** Action-кнопка (CTA для перехода в режим без фильтров). */
  action?: ReactNode;
}

/**
 * Контракт «4 состояния» из STATES.md — состояние Empty, когда данных нет.
 * Используется при пустом search-результате, отсутствии санкций, отзывов и т.п.
 *
 * Не путать с Loading (Skel) — Empty означает что fetch успешен, но result пустой.
 */
export function EmptyState({ icon, title, body, action }: Props) {
  return (
    <div
      className="empty-state"
      role="status"
      aria-live="polite"
      style={{
        textAlign: 'center',
        padding: '32px 16px',
        background: 'var(--surface-quiet, #f5f3ec)',
        border: '1px dashed var(--border, #e6e2d6)',
        borderRadius: 12,
      }}
    >
      {icon && (
        <div aria-hidden="true" style={{ fontSize: 32, marginBottom: 8, lineHeight: 1 }}>
          {icon}
        </div>
      )}
      <div
        style={{
          fontSize: 16,
          fontWeight: 600,
          color: 'var(--navy-700, #0b1736)',
          marginBottom: 6,
        }}
      >
        {title}
      </div>
      {body && (
        <div
          style={{
            fontSize: 14,
            color: 'var(--muted, #6b7287)',
            maxWidth: 380,
            margin: '0 auto',
            overflowWrap: 'anywhere',
          }}
        >
          {body}
        </div>
      )}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
